module.exports = __webpack_public_path__ + "src/assets/games/24/106.jpg";